module.exports = __webpack_public_path__ + "img/HONDA.5c59932.jpg";